import { useCallback, useRef, useState } from 'react';
import { applyErrorHandling, applyErrorReducer } from './ThunkErrorHandler';
import { applyLogging } from './ThunkLogger';
export function createThunkReducer(reducer) { return applyErrorReducer(reducer); }
export function createThunk(thunk) { return applyErrorHandling(applyLogging(thunk)); } // context (apolloClient/navigate/auth) is intentionally left out for now since API
// integration is out of scope for this skeleton; add it here once that work starts
export function useThunkReducer(reducer, initialState) { var stateRef = useRef(initialState); var _a = useState(stateRef.current), state = _a[0], setState = _a[1]; var thunkActionDispatch = useCallback(function (action) { if (typeof action === 'function') {
    action({ state: stateRef.current, dispatch: thunkActionDispatch, context: {}, getState: function () { return stateRef.current; } });
}
else {
    stateRef.current = reducer(stateRef.current, action);
    setState(stateRef.current);
} }, [reducer]); return { state: state, dispatch: thunkActionDispatch }; }
